import {Box, Container, Stack, styled} from '@mui/material';

export const StyledSubHeaderStack = styled(Stack)`
	padding-inline: 16px;
	padding-bottom: 16px;
	gap: 24px;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding-inline: 32px;
	}
`;

export const StyledContainer = styled(Container)`
	padding: 16px;
	max-width: 916px;
	display: flex;
	flex-direction: column;
	gap: 16px;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 24px 32px 32px;
	}
`;

export const StyledBox = styled(Box)`
	margin-bottom: 98px;
	margin-top: auto;

	${({theme}) => theme.breakpoints.up('sm')} {
		margin-bottom: 0px;
	}
`;
